import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import HierarchicalDataUtils from '@usas/ui-web/utils/HierarchicalDataUtils';

const GetOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData = (omeMeetId, omeMeetEntryId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      omeMeetId,
      omeMeetEntryId,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const omeMeetIdForUrl = omeMeetId ? encodeURIComponent(omeMeetId) : 'NaN';
    const omeMeetEntryIdForUrl = omeMeetEntryId ? encodeURIComponent(omeMeetEntryId) : 'NaN';
    const url = `/OmeMeet/${omeMeetIdForUrl}/OmeMeetEntry/${omeMeetEntryIdForUrl}/Organization`;
    MeetHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            treeData: HierarchicalDataUtils.MapArrayToTreeData(arrayData, 'id', 'name'),
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData;